const months = [
    'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu' , 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'
];

const days = [
    'Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'
];

const getUsed = (daysLeft)=>{
    switch (daysLeft) {
        case 0:
            return 50;
        case 1:
            return 50;
        case 2:
            return 50;
        case 3:
            return 50;
        case 4:
            return 50;
        case 5:
            return 36;
        case 6:
            return 31;
        case 7:
            return 25;
        case 8:
            return 24;
        case 9:
            return 13;
        case 10:
            return 9;
        case 11:
            return 7;
        case 12:
            return 5;
        case 13:
            return 3;
        default:
            return 0;
    }
}

const useTrip = ()=>{
    const viaggi = [];
    const today = new Date();
    let tomorrow = new Date(today);
    while(tomorrow.getDay()!==0 || tomorrow.getMonth()<3 || tomorrow.getMonth()>9){
        tomorrow.setDate(tomorrow.getDate() + 1)
    }
    const timeRemain = new Date(tomorrow-today);
    const daysLeft = timeRemain.getDate()-1;
    
    viaggi.push(
        {
            id:"viaggio"+ tomorrow.toLocaleDateString(),
            date:{day:days[tomorrow.getDay()].toUpperCase(), num:tomorrow.getDate(), month:months[tomorrow.getMonth()].toUpperCase()},
            title:"Escursione Bosco Martese",
            text:"Magnifica escursione all'interno del bosco di Faggi della Martese. Tutti i profumi ed i suoni della natura raccolti in un ambiente magico.",
            prenote:{
                used:getUsed(daysLeft),
                max:50,
                isFull: getUsed(daysLeft) === 50 ? true : false,
            }
        }
    )
    tomorrow.setDate(tomorrow.getDate() + 1)
    while(tomorrow.getDay()!==0 && tomorrow.getMonth()>2 && tomorrow.getMonth()<11){
        tomorrow.setDate(tomorrow.getDate() + 1)
    }
    const timeRemain2 = new Date(tomorrow-today);
    const daysLeft2 = timeRemain2.getDate()-1;
    
    viaggi.push(
        {
            id:"viaggio"+ tomorrow.toLocaleDateString(),
            date:{day:days[tomorrow.getDay()].toUpperCase(), num:tomorrow.getDate(), month:months[tomorrow.getMonth()].toUpperCase()},
            title:"Escursione Pizzo di Moscio",
            text:"Esplora le montagne dei Monti della Laga con una passeggiata tra le cime. Tocca i 2411m del Pizzo di Moscio! Passeggiata semplice ed adatta a tutta la famiglia.",
            prenote:{
                used:getUsed(daysLeft2),
                max:50,
                isFull: getUsed(daysLeft2) === 50 ? true : false,
            }
        }
    )
    return {viaggi}
}

export default useTrip;